import axios from "axios";
import store from "@/store";

const apiURL = process.env.VUE_APP_API_URL;

function fetchData(endpoint, requestType, requestBody, authTokenRequired) {
  let apiKey = undefined;
  if (!(authTokenRequired !== undefined && authTokenRequired === false)) {
    if (
      store.state.user &&
      store.state.user.activeUser &&
      store.state.user.activeUser.apiKey
    ) {
      apiKey = store.state.user.activeUser.apiKey;
    } else {
      if (localStorage.getItem("userInfo")) {
        apiKey = JSON.parse(localStorage.getItem("userInfo")).apiKey;
      }
    }
    if (!apiKey) {
      store.commit("user/REMOVE_USER_INFO");
      location.reload();
    }
  }
  let config = "";
  if (authTokenRequired != undefined && authTokenRequired == false) {
    config = {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        platform: "web"
      }
    };
  } else {
    config = {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        platform: "web",
        Authorization: apiKey
      }
    };
  }

  return new Promise((resolve, reject) => {
    if (requestType.toUpperCase() === "POST") {
      return axios
        .post(endpoint, requestBody, config)
        .then(res => resolve(res.data))
        .catch(err => {
          const error = err.response ? err.response.data : err;
          store.dispatch("errorHandler/setErrorMessage", {
            required: true,
            endpoint,
            message: error
          });
          reject(error);
        });
    } else if (requestType.toUpperCase() === "GET") {
      if (requestBody) {
        return axios
          .get(endpoint, { headers: config.headers, params: requestBody })
          .then(res => resolve(res.data))
          .catch(err => {
            const error = err.response ? err.response.data : err;
            store.dispatch("errorHandler/setErrorMessage", {
              required: true,
              endpoint,
              message: error
            });
            reject(error);
          });
      }
      return axios
        .get(endpoint, config)
        .then(res => resolve(res.data))
        .catch(err => {
          const error = err.response ? err.response.data : err;
          store.dispatch("errorHandler/setErrorMessage", {
            required: true,
            endpoint,
            message: error
          });
          reject(error);
        });
    } else if (requestType.toUpperCase() === "PATCH") {
      return axios
        .patch(endpoint, requestBody, config)
        .then(res => resolve(res.data))
        .catch(err => {
          const error = err.response ? err.response.data : err;
          store.dispatch("errorHandler/setErrorMessage", {
            required: true,
            endpoint,
            message: error
          });
          reject(error);
        });
    } else if (requestType.toUpperCase() === "DELETE") {
      if (requestBody) {
        return axios
          .delete(endpoint, { headers: config.headers, data: requestBody })
          .then(res => resolve(res.data))
          .catch(err => {
            const error = err.response ? err.response.data : err;
            store.dispatch("errorHandler/setErrorMessage", {
              required: true,
              endpoint,
              message: error
            });
            reject(error);
          });
      }
      return axios
        .delete(endpoint, config)
        .then(res => resolve(res.data))
        .catch(err => {
          const error = err.response ? err.response.data : err;
          store.dispatch("errorHandler/setErrorMessage", {
            required: true,
            endpoint,
            message: error
          });
          reject(error);
        });
    }
    throw new Error("Unknown HTTP method");
  });
}

export { fetchData, apiURL };
